import {
  tableColumnsWidth,
  key,
  slot,
  renderFn
} from '@/assets/js/resetTableStyle'

// 课程中心 --课程资源
export const trainingTypeList = [
  { name: '全部', value: -1 },
  { name: '素质课', value: 1 },
  { name: '基础托管', value: 2 }
]

export const courseStateList = [
  { name: '全部上架状态', value: -1 },
  { name: '未上架', value: 0 },
  { name: '已上架', value: 1 }
]
export const nameList = [
  { label: '课程名称', value: 'courseName' },
  { label: '课程ID', value: 'courseId' }
]

export const columns = [
  key('课程ID', 'courseId', tableColumnsWidth.type4),

  slot('课程名称', 'courseName', tableColumnsWidth.type6),
  slot('级别', 'courseLevel', tableColumnsWidth.type2),
  key('课程资源学期', 'yearTermName', tableColumnsWidth.type5),
  slot('课程分类', 'courseTypeKind', tableColumnsWidth.type6),
  slot('课程提供方', 'orgName', tableColumnsWidth.type6),
  slot('上架学校', 'schoolName', tableColumnsWidth.type6),
  slot('课程状态', 'isShelves', tableColumnsWidth.type2),
  slot('操作', 'action', 310, { fixed: 'right' })
]
export const columnShelf = [
  {
    type: 'selection',
    width: 60,
    align: 'center'
  },
  {
    title: '学校名称',
    key: 'name',
    align: 'center'
  },
  {
    title: '所属行政区',
    key: 'areaName',
    align: 'center'
  }
]
